/**
 * iOS-Erkennung (iPhone/iPad, inkl. iPadOS, das sich als „Macintosh" tarnt).
 *
 * Für die Aufnahme relevant: iOS-Safari kennt seit iOS 18 zwar `ImageCapture`,
 * aber `takePhoto()` löst dort spürbar verzögert aus und liefert ein SPÄTERES
 * Bild als den Auslöse-Moment. Auf iOS nimmt die Scan-Kamera deshalb eine kurze
 * Bildserie aus dem Live-Video und behält das schärfste Bild (lib/scan/aufnahme.ts).
 */
export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent || "";
  return (
    /iPad|iPhone|iPod/.test(ua) ||
    (/Macintosh/.test(ua) &&
      typeof document !== "undefined" &&
      "ontouchend" in document)
  );
}
